import { trackPhoneClick } from './analytics';
import type { PhoneClickLocation } from './analytics';

const PHONE_LINK_SELECTOR = 'a[href^="tel:"]';

const PHONE_CLICK_LOCATIONS: ReadonlyArray<PhoneClickLocation> = ['header', 'footer', 'hero', 'cta', 'contenu'];

let isInitialized = false;

function isPhoneClickLocation(value: string | undefined): value is PhoneClickLocation {
  return PHONE_CLICK_LOCATIONS.includes(value as PhoneClickLocation);
}

/**
 * Déduit l'emplacement du lien : attribut data-click-location explicite,
 * puis ctaLocation posé par TrackedContactLink, puis <header>/<footer>, sinon contenu.
 */
function getClickLocation(link: HTMLAnchorElement): PhoneClickLocation {
  const explicit = link.closest<HTMLElement>('[data-click-location]')?.dataset.clickLocation;
  if (isPhoneClickLocation(explicit)) return explicit;

  const ctaLocation = link.dataset.ctaLocation;
  if (isPhoneClickLocation(ctaLocation)) return ctaLocation;

  if (link.closest('header')) return 'header';
  if (link.closest('footer')) return 'footer';
  return 'contenu';
}

function handleDocumentClick(event: MouseEvent): void {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest<HTMLAnchorElement>(PHONE_LINK_SELECTOR);
  if (!link) return;
  // Pas de preventDefault : l'appel tel: s'ouvre normalement.
  trackPhoneClick(link.getAttribute('href') ?? '', getClickLocation(link));
}

/** Envoie phone_click pour tout lien tel: du site, y compris ceux ajoutés plus tard. Idempotent. */
export function initPhoneClickTracking(): void {
  if (isInitialized || typeof document === 'undefined') return;
  isInitialized = true;
  document.addEventListener('click', handleDocumentClick, { capture: true });
}
